<template>
  <div class="pt-4 pb-5">
    <div v-if="analisandoDocumento" class="content">
      <transition name="fade">
        <Mensagem
          icon="task_alt"
          title="Estamos validando seus documentos!"
          description="Iremos entrar em contato assim que seus documentos forem validados. Você pode acompanhar os chamados no painel de associados."
          link="/produto/cdl-consultor/minha-carteira"
        />
      </transition>
    </div>
    <div v-else class="cadastroNaoAssociado">
      <div
        class="d-flex flex-column justify-content-between align-items-stretch"
      >
        <div class="row">
          <div class="card-body" v-if="docList.length > 0">
            <Titulo
              title="Documentos"
              description="Arquivos necessários para o cadastro do associado."
            />
            <p v-if="reenvio" class="mt-3 text-danger w-75 font-weight-bold">
              Seus documentos foram inválidados, por favor, revise e envie
              novamente.
            </p>
            <p class="mt-3 text-muted w-75">
              Clique no card para selecionar os documentos para envio
            </p>
            <div class="row mt-4">
              <div
                class="col mt-3 mt-md-0"
                v-for="(card, index) in docList[0].docs"
                :key="index"
              >
                <div
                  class="card file-card border-0 shadow"
                  :class="fileNames.includes(card) ? 'complete' : ''"
                >
                  <div
                    class="card-body d-flex justify-content-between flex-column"
                  >
                    <input
                      type="file"
                      accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                      @change="getFiles(card, $event.target.files)"
                      :ref="'arquivo-' + card"
                      :id="'arquivo-' + card"
                    />
                    <div>
                      <i
                        class="material-icons green"
                        v-if="!fileNames.includes(card)"
                        >description</i
                      >
                      <i class="material-icons green" v-else
                        >check_circle_outline</i
                      >
                      <h3 class="font-weight-bold mt-2 mb-2 text-uppercase">
                        {{ card }}
                      </h3>
                      <small class="small"
                        >Clique neste card para carregar o documento</small
                      >
                    </div>
                    <div></div>
                  </div>
                </div>
                <p
                  v-if="fileNames.includes(card)"
                  class="small text-uppercase mt-2 text-danger d-flex remove-btn align-items-center"
                  @click="removeFile(card, index)"
                >
                  <i class="material-icons mr-2 text-danger">highlight_off</i>
                  remover arquivo
                </p>
              </div>
            </div>
            <p
              class="mt-3 text-muted text-uppercase w-75 d-flex align-items-center small"
            >
              Formatos permitidos: png, jpeg e pdf (tamanho máximo de 10MB por
              arquivo)
            </p>
          </div>
          <div class="mt-4" v-else>
            <div class="col-md-12">
              Não foi possível lista os arquivos, volte para lista de associados
              e tente novamente!
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="$router.push({ name: 'gerenciarAssociados' })"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-3">
          <Botao
            title="Enviar"
            :class="{ disabled: loading }"
            @click="!loading ? enviarDocumentos() : ''"
            nameClass="btn btn-success btn-lg btn-block font-weight-bold"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">ENVIANDO...</span>
            <span v-else>ENVIAR</span>
          </Botao>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Mensagem from "@/components/alertas/Mensagem";
export default {
  name: "Login",
  components: { Titulo, Botao, Mensagem },
  data() {
    return {
      produto: {
        nome: "CDL Consultor",
        id: "cdlConsultor",
      },
      breadcrumb: [
        {
          nome: "CDL Consultor",
          id: "cdlConsultor",
          produto: "CDL Consultor",
        },
        {
          nome: "Cadastrar Associado",
          id: "cadastrarAssociado",
          produto: "CDL Consultor",
        },
      ],
      docList: [
        {
          tipo: "PJ",
          docs: [
            "Contrato Social",
            "Documento de identificacao Societário",
            "Comprovante de Endereco",
          ],
        },
        {
          tipo: "AE",
          docs: [
            "Estatuto",
            "Ata de Nomeação",
            "Documento de identificação do Responsável",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "PL",
          docs: [
            "Carteira de Identificação do conselho",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "AUT",
          docs: [
            "Inscrição do INSS",
            "Última Contribuição INSS",
            "Documento de Identificação",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "MEI",
          docs: [
            "Certificado MEI",
            "Documento de Identificação",
            "Comprovante de Endereço",
          ],
        },
      ],
      codSocio: null,
      files: [],
      fileNames: [],
      loading: false,
      analisandoDocumento: false,
      reenvio: false,
    };
  },
  methods: {
    enviarDocumentos() {
      if (this.files.length < this.docList[0].docs.length) {
        this.$toast.open({
          message: "Você deve adicionar todos os documentos da lista.",
          type: "error",
        });
      } else {
        this.loading = true;
        const files = new FormData();

        this.files.forEach((el) => {
          files.append(
            "files",
            el.file[0],
            el.name + el.file[0].name.substr(-4)
          );
        });

        files.append("codSocio", this.codSocio);
        this.$http
          .post(`api/Consultor/AnexarDocumentacaoAssociado`, files)
          .then((response) => {
            if (response.data.mensagem) {
              this.$store.dispatch("getUserData");
              this.$toast.open({
                message: response.data.mensagem,
                type: "success",
              });

              this.files = [];
              this.fileNames = [];
              var filesInput = document.querySelectorAll("input");
              filesInput.forEach((e) => {
                e.value = null;
              });
              this.loading = false;
              this.analisandoDocumento = true;
            } else {
              this.$toast.open({
                message: "Erro no envio dos seus arquivos, tente novamente.",
                type: "error",
              });
              this.loading = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.open({
              message: "Erro no envio dos seus arquivos, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
    removeFile(name) {
      this.files.splice(name, 1);
      this.fileNames.splice(name, 1);
      document.getElementById("arquivo-" + name).value = null;
    },
    getFiles(name, file) {
      this.renameFile(file, name);
      this.fileNames.push(name);
      this.files.push({ name, file });
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.codSocio = localStorage.getItem("associadoSelecionado");
    var dadosSocio = null;
    await this.$http
      .get(`api/Consultor/ConsultarAssociado?codSocio=${this.codSocio}`)
      .then((response) => {
        dadosSocio = response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
    await this.$http
      .get(`/api/Consultor/ConsultarChamados?codSocio=${this.codSocio}`)
      .then((response) => {
        if (response.data.length) {
          var returnFluig = null;
          returnFluig = response.data[response.data.length - 1];

          if (
            returnFluig.comprovanteConselho &&
            returnFluig.comprovanteConselho.split(/\W+/).includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.comprovanteEndereco &&
            returnFluig.comprovanteEndereco.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.comprovanteReceidaFederal &&
            returnFluig.comprovanteReceidaFederal.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.contratoSocial &&
            returnFluig.contratoSocial.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.declaracaoTributacao &&
            returnFluig.declaracaoTributacao.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.documentoIdentificacao &&
            returnFluig.documentoIdentificacao.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.guiaInssPago &&
            returnFluig.guiaInssPago.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
          if (
            returnFluig.pisOuNid &&
            returnFluig.pisOuNid.includes("INCORRETA")
          ) {
            this.reenvio = true;
          }
        }
      });
    var tpEmpresa = dadosSocio.tP_EMPRESA ? dadosSocio.tP_EMPRESA : "PJ";

    this.docList = this.docList.filter((el) => el.tipo === tpEmpresa);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.cadastroNaoAssociado /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  background: white;
  padding: 2rem;
  border-radius: 6px;
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
        height: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
  }
}
.visibility {
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
.file-card {
  min-height: 200px;
  transition: all 0.2s ease-in-out;
  position: relative;
  cursor: pointer;
  input[type="file"] {
    cursor: pointer;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 2;
  }
  &:hover {
    transform: translateY(-5px);
  }
}
</style>
